import { Box, Card, CardContent, TextField, Button, Typography, Alert, Link } from '@mui/material';
import { PointOfSale, ArrowBack } from '@mui/icons-material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link as RouterLink } from 'react-router-dom';
import api from '../../api/axios';

export default function ForgotPasswordPage() {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async ({ email }) => {
    setLoading(true); setErr('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (e) {
      setErr(e.response?.data?.message || 'Error sending email');
    } finally { setLoading(false); }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 2 }}>
      <Card sx={{ maxWidth: 420, width: '100%' }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 56, height: 56, bgcolor: 'primary.main', borderRadius: 3, mb: 2 }}>
              <PointOfSale sx={{ color: 'white', fontSize: 28 }} />
            </Box>
            <Typography variant="h5" fontWeight={700}>Forgot Password</Typography>
            <Typography variant="body2" color="text.secondary" mt={0.5}>Enter your email to receive a reset link</Typography>
          </Box>

          {sent ? (
            <Alert severity="success" sx={{ borderRadius: 2 }}>
              Reset link sent! Check your email inbox (and spam folder).
            </Alert>
          ) : (
            <>
              {err && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{err}</Alert>}
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <TextField
                  fullWidth label="Email Address" margin="normal" autoComplete="email"
                  error={!!errors.email} helperText={errors.email?.message}
                  {...register('email', { required: 'Email is required', pattern: { value: /^\S+@\S+$/i, message: 'Invalid email' } })}
                />
                <Button fullWidth variant="contained" type="submit" disabled={loading} size="large" sx={{ py: 1.5, mt: 2 }}>
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </Button>
              </Box>
            </>
          )}

          <Box sx={{ textAlign: 'center', mt: 3 }}>
            <Link component={RouterLink} to="/login" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
              <ArrowBack fontSize="small" /> Back to Login
            </Link>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
